module.exports = __webpack_public_path__ + "static/media/nss.7b07594d.png";